import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		headData: [
			{
				title: "发票数据",
				children: [
					{
						title: "公司编号",
						prop: "companyCode",
						width: "200"
					},
					{
						title: "业务类型",
						prop: "businessTypeName",
						width: "200"
					},
					{
						title: "发票类型",
						prop: "faplx",
						width: "200",
						custom: true
					},
					{
						title: "发票号码",
						prop: "faphm",
						width: "200"
					},
					{
						title: "开票日期",
						prop: "kaiprq",
						width: "200"
					},
					{
						title: "开票金额",
						prop: "jine",
						width: "200"
					},
					{
						title: "开票税额",
						prop: "shuie",
						width: "200"
					},
					{
						title: "操作",
						prop: "cz",
						width: "200",
						custom: true
					}
				]
			},
			{
				title: "处理状态",
				children: [
					{
						title: "处理状态",
						prop: "status",
						width: "200",
						custom: true
					},
					{
						title: "Remark",
						prop: "remark",
						width: "200",
						custom: true
					}
				]
			}
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		nsrsbhData: [{
			nsrsbh: "",
			nsrmc: ""
		}],
		initdata:[
			{
				companyCode:'1',
				businessType:'2',
				subjectCode:'3',
				voucherNo:'4',
				jizrq:'5',
				shuil:'6',
				jizje:'7',
				billingNo:'8',
				voucherRemark:'9',
				companyCode0:'10',
				companyCode:'11',
				faphm:'12',
				kaiprq:'13',
				jine:'14',
				shuie:'15',
				companyCode6:'16',
				companyCode7:'17',
				companyCode8:'18',
				companyCode9:'19',
				businessType0:'20',
				taxDiff:'21',
				status:'22',
				remark:'23',
				businessType4:'24',
				businessType5:'25',
				businessType6:'26'
			}
		]
	}
	return obj
}
